// extracted by mini-css-extract-plugin
export default {"smaller":"Q14L1qQ3I1ECJ5wYf9Eb","flexStop":"WBBx9xEbN7_XyxalKf2B","padding":"kR81m7Uoz4QB1JxIjvMP"};